'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { Button, Typography, Input } from '@/components/atoms';
import { logger } from '@/lib/logger';

import type { UserPlaylist } from '@/lib/contexts/favouriting';

export interface CreatePlaylistProps {
  createUserPlaylistAndStore: (name: string) => Promise<UserPlaylist | null>;
  addTrackToUserPlaylist: (
    playlistId: number,
    trackId: number,
  ) => Promise<void>;
  fetchUserPlaylists: () => Promise<void>;
  trackId?: number;
  onDone: () => void;
}

export const CreatePlaylistForm = ({
  createUserPlaylistAndStore,
  addTrackToUserPlaylist,
  fetchUserPlaylists,
  trackId,
  onDone,
}: CreatePlaylistProps) => {
  const t = useTranslations();
  const [newPlaylistName, setNewPlaylistName] = useState('');

  const handleCreateAndAdd = async () => {
    if (!newPlaylistName || newPlaylistName === '') return;
    try {
      const playlist = await createUserPlaylistAndStore(newPlaylistName);
      await fetchUserPlaylists();
      if (trackId && playlist) {
        await addTrackToUserPlaylist(playlist.id, trackId);
      }
      onDone();
    } catch (err) {
      logger.error(err, {
        context: 'Failed to create and add track to playlist',
      });
    }
  };
  return (
    <div className="w-full">
      <Typography.Text
        variant="body"
        size="lg"
        weight="medium"
        className="w-full text-center"
      >
        {t('MY_LIBRARY_PLAYLISTS_CREATE_NEW')}
      </Typography.Text>
      <Typography.Text
        variant="paragraph"
        size="md"
        weight="medium"
        className="w-full text-left"
      >
        {t('CREATE_PLAYLIST_TITLE_LABEL')}
      </Typography.Text>
      <Input
        placeholder={t('CREATE_PLAYLIST_PLACEHOLDER')}
        value={newPlaylistName}
        onChange={e => {
          setNewPlaylistName(e.target.value);
        }}
        variant={'default'}
        className="w-full mt-2 mb-2"
      />
      <Button
        size="sm"
        variant="primary"
        className="w-full mt-2"
        onClick={handleCreateAndAdd}
      >
        {t('CREATE_PLAYLIST')}
      </Button>
    </div>
  );
};
